import { companyDb } from '../supabaseClient.ts';

export async function logTutorSessionEvent(
  sessionId: string | null | undefined,
  eventType: 'question_attempt' | 'lesson_view',
  payload: Record<string, unknown>,
) {
  if (!sessionId) return;
  const { error } = await companyDb
    .from('tutor_session_events')
    .insert({
      session_id: sessionId,
      event_type: eventType,
      payload,
    });
  if (error) {
    console.warn('[tutor-session] failed to log event', error.message);
  }
}
